
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import { PageHeader } from '../components'
import { SaveButton } from '@/components/buttons'
import { SchoolStudentDto } from '@ViewModels/SchoolStudentDto'
import { MultiSelect } from '@/components/formGroups'
import { DatePicker } from '@/components/input'

export default Vue.extend({
   name: 'StudentBulkCreate',
   props: {
      schoolId: { type: String, default: '' },
      settings: { type: Boolean, default: false}
   },
   data() {
      return {
         items: [] as SchoolStudentDto[],
         loading: true,
         saving: false,
         selectedClassRoomIds: [] as string[],
         classroomOptions: [] as NameValuePair[],
         genderOptions: [
            { name: 'Female', value: 0 },
            { name: 'Male', value: 1 },
         ] as NameValuePair[],
      }
   },
   computed: {
      activeSchoolId(): string {
         return this.schoolId ? this.schoolId : this.$store.getters.activeSchoolId
      },
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      selectedClassNames(): string {
         if (this.selectedClassRoomIds.length === 0) {
            return '[no classes selected!]'
         }
         return this.selectedClassRoomIds
            .map((classId: string) => {
               const match = this.classroomOptions.find(opt => opt.value === classId)
               return match ? match.name : ''
            })
            .join(', ')
      },
      buttonCaption(): string {
         return `Save ${this.items.length} Student${this.items.length === 1 ? '' : 's'} in ${
            this.selectedClassNames
         }`
      },
      itemsToSave(): SchoolStudentDto[] {
         return this.items.filter(item => {
            return !!item.FirstName && !!item.LastName
         })
      },
      canSave(): boolean {
         return this.selectedClassRoomIds.length > 0 && this.itemsToSave.length > 0
      },
      selectedSchoolYear(): number {
         return this.$store.getters.selectedSchoolYear
      },
      crumbs(): Breadcrumb[] {
         return [
            {
               text: 'Students',
               route: 'student-list',
               params: { schoolId: this.activeSchoolId, settings: this.settings },
            },
            { text: 'Add Multiple Students' },
         ]
      },
   },
   mounted() {
      this.addDefaultItemToList()
      this.selectedClassRoomIds = this.$store.getters.classroomIdsFilter
      this.loadClassroomOptions()
      this.loading = false
   },
   methods: {
      async loadClassroomOptions() {
         this.classroomOptions = await Api.getClassroomOptionsForSchoolYear(
            this.activeSchoolId,
            this.selectedSchoolYear
         )
      },
      removeItem(item: SchoolStudentDto) {
         this.items.splice(this.items.indexOf(item), 1)
      },
      async saveItem() {
         this.itemsToSave.forEach(item => {
            item.ClassRoomIds = this.selectedClassRoomIds
         })
         try {
            this.saving = true
            await Api.saveBulkSchoolStudents(this.itemsToSave)
            this.$router.push({
               name: 'student-list',
               params: { schoolId: this.activeSchoolId, settings: this.settings } as any,
            })
         } finally {
            this.saving = false
         }
      },

      async addDefaultItemToList() {
         const newItem = {} as SchoolStudentDto
         Vue.$assign(newItem, this.$store.getters.emptySchoolStudentDto)
         newItem.SchoolId = this.activeSchoolId
         newItem.IsEnabled = true
         this.items.push(newItem)
      },
   },
   components: {
      PageHeader,
      SaveButton,
      MultiSelect,
      DatePicker,
   },
})
